import { createRequestActionTypes } from '../../helpers'

export const START_CALL = createRequestActionTypes('CALL_HANDLER', 'START')
export const STOP_CALL = createRequestActionTypes('CALL_HANDLER', 'STOP')
export const GET_SESSION = createRequestActionTypes(
  'CALL_HANDLER',
  'GET_SESSION'
)
